import React from 'react';
const bonuses = [{
  number: 1,
  title: 'Recetario Saludable para Perros',
  description: '10 recetas caseras seguras + guía de alimentos prohibidos.',
  image: 'https://cdn.magicpatterns.com/uploads/7oSDgstsxBcDnv1pKGYmeS/Recetas_Saludables_para_PERROS.png'
}, {
  number: 2,
  title: 'Recetario Saludable para Gatos',
  description: '10 recetas caseras seguras + lista específica de alimentos peligrosos.',
  image: 'https://cdn.magicpatterns.com/uploads/gkWvzB5bkTBmjU1mzJjHyB/Recetas_Saludables_para_GATOS.png'
}, {
  number: 3,
  title: '12 Errores silenciosos que perjudican a tu Mascota',
  description: '6 errores en perros y 6 errores en gatos con soluciones prácticas.',
  image: 'https://cdn.magicpatterns.com/uploads/h47SECvgDcxAkzv9zixK5e/12_Errores_que_perjudican_a_tu_mascota.png'
}, {
  number: 4,
  title: 'Guía Práctica de Adiestramiento Canino',
  description: 'Órdenes básicas y técnicas simples para corregir conductas problemáticas.',
  image: 'https://cdn.magicpatterns.com/uploads/rhdodAYG4JHGsozDcP1Y8t/Guia_Adiestramiento_Canino.png'
}, {
  number: 5,
  title: '15 Juegos Caseros para Estimular a Tu Mascota',
  description: 'Ideas divertidas para mantener a tu perro o gato activo y estimular su mente.',
  image: 'https://cdn.magicpatterns.com/uploads/nSy1DY7ToVdjd6HwBbmXm8/15_Juegos_Caseros.png'
}];
export function BonusSection() {
  return <section className="bg-gradient-to-b from-[#EFF4FF] to-white py-10 px-4" data-id="element-32">
      <div className="max-w-6xl mx-auto" data-id="element-33">
        <div className="text-center mb-8" data-id="element-34">
          <span className="inline-block py-1 px-3 rounded-full bg-blue-100 text-blue-700 text-xs font-bold mb-3 tracking-wide" data-id="element-35">
            OFERTA ESPECIAL
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#111827]" data-id="element-36">
            ¡SOLO POR HOY recibís 5 ebooks adicionales GRATIS!
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4" data-id="element-37">
          {bonuses.map(bonus => <div key={bonus.number} className="bg-white rounded-xl shadow-md border border-blue-100 flex flex-col h-full relative overflow-hidden group" data-id="element-38">
              <div className="absolute top-1.5 right-1.5 bg-blue-600 text-white text-[10px] font-bold px-2 py-0.5 rounded z-10" data-id="element-39">
                #{bonus.number}
              </div>
              <div className="w-full aspect-[3/4] overflow-hidden" data-id="element-40">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-41" />
              </div>
              <div className="p-3 flex flex-col flex-grow" data-id="element-42">
                <h3 className="text-xs md:text-sm font-bold text-[#111827] mb-1 leading-snug" data-id="element-43">
                  {bonus.title}
                </h3>
                <p className="text-[#4B5563] text-[11px] leading-tight mb-2 flex-grow hidden md:block" data-id="element-44">
                  {bonus.description}
                </p>
                <div className="pt-2 border-t border-gray-100" data-id="element-45">
                  <p className="text-[10px] text-gray-400 line-through" data-id="element-46">
                    ANTES: $10.000
                  </p>
                  <p className="text-sm font-bold text-green-600" data-id="element-47">GRATIS</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}